export default {
  options: {
    true: 'Yes',
    false: 'No',
  },
};
